import { memo, useCallback, useRef, useState } from 'react'
import { useLoading } from '../components/Loading'
import { getUserInfo, loginByPassword, setAccessToken } from '../utils/userApi'
import { Button, Divider, Input, Message, Modal } from '@arco-design/web-react'
import { IconLock, IconPhone, IconUser } from '@arco-design/web-react/icon'
import { useLocation, useNavigate } from 'react-router-dom'
import PageMask from '../components/PageMask'
import XIF from '../components/utils/XIF'
import LogoHead from '../components/LogoHead'
import styled from 'styled-components'
import ZWContract from '../components/ZWContract'
import SmsLoginModal from '../components/SmsLoginModal'
import { useEffectAsync } from '../utils/common'
import {showKefuDialog} from "./MainPage";

const LoginPage = memo(() => {
  const accountRef = useRef(null)
  const passwdRef = useRef(null)
  const { setLoading } = useLoading()
  const [isPhoneLogin, setPhoneLogin] = useState(false)

  const { search } = useLocation()
  const queryParams = new URLSearchParams(search)
  const redirect = queryParams.get('redirect')
  const navigate = useNavigate()
  const [isLogin, setLogin] = useState(false)
  let isMobile = true

  useEffectAsync(async () => {
    const rsp = await getUserInfo()
    if (rsp.code !== 0) return
    navigate(redirect ?? '/')
  }, [navigate, redirect])

  const handleLoginResult = useCallback((rsp) => {
    if (rsp?.code !== 0) {
      Modal.error({
        title: '登录失败',
        content: rsp['msg'],
      })
      return
    }
    Message.success('登录成功！')
    setLogin(true)
    setAccessToken(rsp.data['access_token'])
    setTimeout(() => {
      navigate(redirect ?? '/')
    }, 1000)
  }, [navigate, redirect])

  const onTryLoginByPasswd = useCallback(async (e) => {
    const account = accountRef.current.dom.value
    const passwd = passwdRef.current.dom.value
    setLoading(true)
    const r = await loginByPassword(account, passwd)
    setLoading(false)
    handleLoginResult(r)
  }, [])

  const [isAgree, setAgree] = useState(true)

  return <PageMask enable={isLogin}>
    <XIF condition={!isLogin}>
      <SmsLoginModal handleLoginResult={handleLoginResult}
                     setPhoneLogin={setPhoneLogin}
                     isPhoneLogin={isPhoneLogin}
      />
    </XIF>
    <Root>
      <head>
        <title>Cochiper - 登录</title>
      </head>
      <Window>
        <LogoHead/>
        <div className="content">
          <Input ref={accountRef}
                 id="account"
                 className="item" placeholder="请输入账号"
                 prefix={<IconUser/>}/>
          <Input ref={passwdRef}
                 id="password"
                 className="item" placeholder="请输入密码"
                 type="password"
                 prefix={<IconLock/>}/>
          <Button className="submit" disabled={!isAgree}
                  type="primary"
                  onClick={onTryLoginByPasswd}>登录</Button>
          <Button className="item"
                  onClick={(e) => {
                    showKefuDialog()
                  }}
          >没有账号？点击此处获取！</Button>
        </div>
        <ZWContract setAgree={setAgree}/>
      </Window>
    </Root>
  </PageMask>
})

export default LoginPage

const Window = styled.div`
  height: 100%;
  padding: 10px;
  border-radius: 15px;
  background: white;
  box-shadow: 1px 1px 10px #b9b9b9;
`

const Root = styled.div`
  height: calc(100vh - 20px);

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .item {
      width: 80%;
      margin: 5px;
      height: 40px;
    }

    a {
      text-decoration: none;
    }

    .submit {
      margin-top: 10px;
      width: 80%;
      height: 40px;
    }
  }

`
